<template>
  <view-receivers-data />
</template>
<script>
import ViewReceiversData from "./ViewReceiversData.vue";
export default {
  name: "view-receivers-page",
  components: {
    ViewReceiversData
  },
  data() {
    return {};
  }
};
</script>
